/*
 * ******************************************************************
 * Copyright (c) 2024-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from "@angular/core";

import * as Highcharts from "highcharts";
import darkTheme from "highcharts/themes/high-contrast-dark";
import lightTheme from "highcharts/themes/high-contrast-light";
import { ThemeService } from "@app/services";

@Component({
    standalone: false,
    selector: 'horizontal-bar-chart',
    templateUrl: './horizontal-bar-chart.component.html',
    styleUrls: ['./horizontal-bar-chart.component.scss'],
})
export class HorizontalBarChartComponent implements AfterViewInit, OnChanges {

    @ViewChild('chartRef') chartRef: ElementRef;

    @Input() title: string;
    @Input() categories: any;
    @Input() series: Highcharts.SeriesOptionsType[];


    constructor(private themeService: ThemeService) {
        if (this.themeService.isDarkTheme()) {
            darkTheme(Highcharts);
        } else {
            lightTheme(Highcharts);
        }
    }

    ngAfterViewInit(): void {
        this.drawChart();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['series']?.previousValue != undefined && changes['series'].currentValue != changes['series'].previousValue) {
            this.drawChart();
        }
    }

    private drawChart(): void {
        // @ts-expect-error javascript callback
        Highcharts.chart(this.chartRef.nativeElement, {
            chart: {
                type: 'column',
                backgroundColor: 'transparent'
            },
            title: {
                text: this.title ? this.title : null,
                align: 'left'
            },
            xAxis: {
                categories: this.categories,
                visible: true,
                gridLineWidth: 0,
                lineWidth: 0,
                tickWidth: 0,
                min: null
            },
            yAxis: [{
                min: 0,
                title: {
                    enabled: false,
                }
            }],
            legend: {
                events: {
                    itemClick: _event => {
                        return false
                    }
                }
            },
            tooltip: {
                shared: true
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                column: {
                    shadow: false,
                    borderWidth: 0
                },
                series: {
                    stacking: 'normal'
                }
            },
            series: this.series ? this.series : []
        });
    }
}
